/**
 * @(#)2020/3/30.
 * Range，用于输入数字区间
 * @author 飞光
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */
import React, { Component } from "react";
import { Row, Col } from "antd";
import Basics from "../Basics";
import Number from "../Number";
import { get } from "../../../utils";
import { YxComponent, Connection } from "../../YxComponent";
import { isArray, isEqual } from "lodash";

/*
 * -----------------------公共部分参数--------------------------------------------------
 * @param onChange {object} 输入框发生变化的回调，返回对象为一个数组
 * @param section {array<Number,Number>} 区间，数组第一项/第二项为数组，数组可包含一个数字或两个数字，为一个数字时，该输入框的最小值和
 *        最大值都为该数字，为两个数字时，数组的第一个值和第二个值为第一个/第二个输入框的最小值和最大值
 * [1,2] 或   [[1,2],[3,4]]
 * @param firstParams {object} 第一个输入框的参数，继承Number属性
 * @param secondParams {object} 第一个输入框的参数，继承Number属性
 * @param defaultValue {array<Number,Number>}  默认值
 * */

//默认props
let defaul = () => {
  return {
    section: null, //区间
    getFieldDecorator: {},
    firstParams: {},
    secondParams: {},
    defaultValue: ["", ""],
  };
};
@Connection(defaul)
class NumberRange extends YxComponent {
  constructor(props) {
    super(props);
    this.state = {
      value: ["", ""],
    };
  }

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {
    let tmpProps = this.props;
    let { setFieldsValue } = tmpProps.form;
    let setValue = get(nextProps, "setValue");
    if (setValue) {
      let setInputParam = {
        [tmpProps.id + "First"]: setValue[0],
        [tmpProps.id + "Second"]: setValue[1],
      };
      if (isArray(setValue) && !isEqual(setValue, tmpProps.setValue)) {
        setFieldsValue(setInputParam);
        this.state.value = setValue;
      }
    }
  }
  change(e, idx) {
    this.state.value[idx] = e;
    this.props.onChange(this.state.value);
  }
  numberProps(tmpProps) {
    let section = tmpProps.section;
    let sectionParam = [];
    let baics = {
      styleParam: {
        width: "xxs", //宽度  xxs,xs,sm,md,lg,xl
      },
      form: tmpProps.form,
    };
    //设置区间值
    if (isArray(section)) {
      if (isArray(section[0]) && section[0].length == 2) {
        sectionParam[0] = { max: "", min: "" };
        sectionParam[0].min = section[0][0];
        sectionParam[0].max = section[0][1];
      } else {
        sectionParam[0] = { max: "" };
        section[0] ? (sectionParam[0].max = section[0]) : "";
      }
      if (isArray(section[1]) && section[1].length == 2) {
        sectionParam[1] = { max: "", min: "" };
        sectionParam[1].min = section[1][0];
        sectionParam[1].max = section[1][1];
      } else {
        sectionParam[1] = { max: "" };
        section[1] ? (sectionParam[1].max = section[1]) : "";
      }
    }
    return [
      //最小范围框
      {
        ...baics,
        defaultValue: get(tmpProps, "defaultValue[0]", ""),
        ...sectionParam[0],
        id: tmpProps.id + "First",
        change: (e, dateString) => {
          this.change(e, 0);
        },
        ...tmpProps.firstParams,
      },
      //最大范围框
      {
        ...baics,
        defaultValue: get(tmpProps, "defaultValue[1]", ""),
        ...sectionParam[1],
        id: tmpProps.id + "Second",
        change: (e, dateString) => {
          this.change(e, 1);
        },
        ...tmpProps.secondParams,
      },
    ];
  }

  paramError(tmpProps) {
    if (!isArray(get(tmpProps, "defaultValue"))) {
      console.error("defaultValue参数格式不准确，正确格式为[Number,Number]");
    }
    if (get(tmpProps, "section") && !isArray(get(tmpProps, "section"))) {
      console.error(
        "section参数格式不准确，正确格式为[Number,Number] 或  [[Number,Number],[Number,Number]]"
      );
    }
  }

  productionHtml() {
    let tmpProps = this.props;
    let html = "";
    this.paramError(tmpProps);
    //回调函数
    html = (
      <Row>
        <Col span={10}>
          <Number {...this.numberProps(tmpProps)[0]} />
        </Col>
        <Col
          span={4}
          type="flex"
          className="yx_yxInput_range_interval"
          justify="center"
          align="center"
        >
          {" "}
          -{" "}
        </Col>
        <Col span={10}>
          <Number {...this.numberProps(tmpProps)[1]} />
        </Col>
      </Row>
    );
    return html;
  }

  render() {
    //合并默认参数和外部参数
    return this.productionHtml();
  }
}
export default NumberRange;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/Range/Range.js